import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useState, useEffect } from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import axios from "axios";
import Logo from "../../../assets/image/logo.png";
import DashBoard from "./DashBoard";
import Footer from "../footer/Footer";
import { useNavigate } from "react-router-dom";
import "../../../assets/CustomNavbar.css"; // Import your custom styles
import { storage } from "../../../utils/auth";
function ExhibitorDashboardNavbar() {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [area, setArea] = useState(false);
  const [exhibitor, setExhibitor] = useState(false);
  const [vendor, setVendor] = useState(false);
  const [visitor, setVisitor] = useState(false);
  const [spotRegistration, setSpotRegistration] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [completedataByYear, setCompleteDataByYear] = useState(false);
  const [data2019, setData2019] = useState(false);
  const [showSetting, setshowSetting] = useState(false);
  const [cabmanagement, setCabManagement] = useState(false);
  const [hotelmanagement, setHotelManagement] = useState(false);

  const navigate = useNavigate();

  const showSettingDropdown = (e) => {
    setshowSetting(!showSetting);
  };
  const hideSettingDropdown = (e) => {
    setshowSetting(false);
  };

  const [brandingLogo, setBrandingLogo] = useState("");

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`)
      .then((res) => {
        if (res.data.data && res.data.data.branding_logo) {
          setBrandingLogo(res.data.data.branding_logo);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const logoSrc = brandingLogo
    ? `${process.env.REACT_APP_IMAGE_URL}/branding/${brandingLogo}`
    : Logo;

  const handleLogout = (e) => {
    storage.clearNamespace("superadmin");
    navigate("/superadmin/login");
  };

  return (
    <>
      <Navbar className="custom-navbar" expand="lg">
        <div className="d-flex">
          <a>
            <img
              src={logoSrc}
              alt="logo-img"
              className="my-1 mx-5"
              style={{ height: "80px", width: "auto", maxWidth: "250px", cursor: "pointer" }}
              onClick={() => navigate("/superadmin/dashboard")}
            />
          </a>
          {/* <div className="d-flex mx-auto align-items-center">
          <span className="fw-bold fs-1" style={{ textAlign: "center" }}>
            {currentYear}
          </span>
        </div> */}
        </div>
        <Container>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="me-auto my-2 my-lg-0" navbarScroll>
              <Nav.Link onClick={() => navigate("/superadmin/dashboard")}>
                Dashboard
              </Nav.Link>
              <NavDropdown
                title="Area"
                id="collasible-nav-dropdown"
                show={area}
                onMouseEnter={() => setArea(true)}
                onMouseLeave={() => setArea(false)}
              >
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/add-area")}
                >
                  Add Area
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/area-list")}
                >
                  Area List
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown
                title="Exhibitor"
                id="collasible-nav-dropdown"
                show={exhibitor}
                onMouseEnter={() => setExhibitor(true)}
                onMouseLeave={() => setExhibitor(false)}
              >
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/add-exhibitor")}
                >
                  Add Exihibitor
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/exhibitor-list")}
                >
                  Exihibitor List
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/exhibitor-report")}
                >
                  Exihibitor Report
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/vip-guest")}
                >
                  Buyers Request List
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/invited-vip-guest")}
                >
                  Invited Buyer List
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/recycled-vip")}
                >
                  Recycled Buyer list
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown
                title="Vendor"
                id="collasible-nav-dropdown"
                show={vendor}
                onMouseEnter={() => setVendor(true)}
                onMouseLeave={() => setVendor(false)}
              >
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/add-vender")}
                >
                  Add Vendor
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/vender-list")}
                >
                  Vender List
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown
                title="Visitor"
                id="collasible-nav-dropdown"
                show={visitor}
                onMouseEnter={() => setVisitor(true)}
                onMouseLeave={() => setVisitor(false)}
              >
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/vis-req-li")}
                >
                  Visitor Request List
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/acc-vis-li")}
                >
                  Accepted Visited List
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/hol-vis-li")}
                >
                  Hold Visitor List
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/rej-vis-li")}
                >
                  Rejected Visited List
                </NavDropdown.Item>
                {/* <NavDropdown.Item
                  onClick={() => navigate("/superadmin/age-li")}
                >
                  Agent List
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/app-age-li")}
                >
                  Approved Agent List
                </NavDropdown.Item> */}
                {/* <NavDropdown.Item
                  onClick={() => navigate("/superadmin/category")}
                >
                  Visitor Category
                </NavDropdown.Item> */}
              </NavDropdown>

              <Nav.Link
                title="Spot-Registration"
                show={spotRegistration}
                onClick={() => navigate("/superadmin/hotel-registration")}
              >
                Hotels
              </Nav.Link>
              <NavDropdown
                title="Cab Management"
                id="collasible-nav-dropdown"
                show={cabmanagement}
                onMouseEnter={() => setCabManagement(true)}
                onMouseLeave={() => setCabManagement(false)}
              >
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/cab-mangement-list")}
                >
                  Cab Management List
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown
                title="Hotel Management"
                id="collasible-nav-dropdown"
                show={hotelmanagement}
                onMouseEnter={() => setHotelManagement(true)}
                onMouseLeave={() => setHotelManagement(false)}
              >
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/hotel-management-list")}
                >
                  Hotel Management List
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                title="Setting"
                id="collasible-nav-dropdown"
                show={showSetting}
                align="end"
                onMouseEnter={showSettingDropdown}
                onMouseLeave={hideSettingDropdown}
              >
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/registration-setting")}
                >
                  Registration Setting
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/email-sms-setting")}
                >
                  E-Mail/SMS Setting
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/branding-setting")}
                >
                  Branding Setting
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/download-pics-zip")}
                >
                  Download Pics
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/subadmin-management")}
                >
                  Sub-Admin Setting
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => navigate("/superadmin/change-password")}
                >
                  Change Password
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => {
                    handleLogout("superAdmin");
                  }}
                >
                  Logout
                </NavDropdown.Item>
              </NavDropdown>

              {/* <Nav.Link onClick={() => navigate("/superadmin/file-manager")}>
                File Manager
              </Nav.Link> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}
export default ExhibitorDashboardNavbar;
